import "../styles/AvwakinDevelopmentPage.css";

function AvwakinFooter() {
  return (
    <footer className="avwakin-footer">
      <div className="avwakin-footer-inner">
        <p className="footer-title">Avwakin Development</p>

        <p>
          Custom systems without restriction.
        </p>

        <p>
          Designed and maintained by Kenneth L. Powell.
        </p>

        <p className="footer-copy">
          © {new Date().getFullYear()} Avwakin Development
        </p>
      </div>
    </footer>
  );
}

export default AvwakinFooter;
